<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <!-- table start -->
        <app-advanced-table *ngIf="loaded" [tableData]="records" [columns]="columns" [pagination]="true"
          [pageSizeOptions]="pageSizeOptions" [hasRowSelection]="true" [isSearchable]="true"
          (search)="searchData($event)" [isSortable]="true" (sort)="onSort($event)" [buttonLink]="buttonLink"
          [buttonTitle]="buttonTitle" (deleteClick)="openDeleteModal($event)"
          (estadoClick)="openEstadoModal($event)">
        </app-advanced-table>

        <div id="status" *ngIf="!loaded && !error">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <ngb-alert [dismissible]="false" type="danger" *ngIf="error">
          {{ error }}
        </ngb-alert>
      </div> <!-- end card body-->
    </div> <!-- end card -->
  </div><!-- end col-->
</div>

<!-- Modal para confirmar activacion/desactivacion -->
<div class="confirm-delete-modal" *ngIf="showConfirmEstadoModal">
  <div class="confirm-delete-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title">
        <span *ngIf="estadoAction === 'DESACTIVAR'" i18n>Confirmar desactivación</span>
        <span *ngIf="estadoAction === 'ACTIVAR'" i18n>Confirmar activación</span>
      </h5>
    </div>
    <div class="confirm-delete-modal-body">
      <p *ngIf="estadoAction === 'DESACTIVAR'" i18n>¿Está seguro que desea desactivar este usuario? Quedará inactivo, no validado y no podrá acceder a la plataforma. Sus datos no se borran y se mantiene asociado a los casos.</p>
      <p *ngIf="estadoAction === 'ACTIVAR'" i18n>¿Está seguro que desea activar este usuario? Quedará activo pero no validado. Podrá acceder a la plataforma, pero previamente debe hacer el proceso de regeneración de contraseña.</p>
    </div>
    <div class="confirm-delete-modal-footer">
      <button type="button" class="btn waves-effect waves-light" style="margin-right: 20px;"
        [ngClass]="estadoAction === 'DESACTIVAR' ? 'btn-danger' : 'btn-success'"
        (click)="confirmEstado()">
        <span class="btn-label"><i class="fe-power"></i></span>
        <span *ngIf="estadoAction === 'DESACTIVAR'" i18n>Desactivar</span>
        <span *ngIf="estadoAction === 'ACTIVAR'" i18n>Activar</span>
      </button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeEstadoModal()">
        <span class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span>
      </button>
    </div>
  </div>
</div>
<!-- end row-->

<!-- Modal para confirmar borrado -->
<div class="confirm-delete-modal" *ngIf="showConfirmDeleteModal">
  <div class="confirm-delete-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Confirmar Borrado</h5>
    </div>
    <div class="confirm-delete-modal-body">
      <p><span i18n>¿Está seguro que desea borrar al usuario</span> "{{ arbitroToDelete?.nombre }} {{ arbitroToDelete?.apellidos }}"?. <span i18n>Este usuario NO está validado y NO está asociado a ningún caso.</span></p>
    </div>
    <div class="confirm-delete-modal-footer">
      <button type="button" class="btn btn-danger waves-effect waves-light" style="margin-right: 20px;"
        (click)="confirmDelete()">
        <span class="btn-label"><i class="fe-trash"></i></span><span i18n>Borrar</span>
      </button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeDeleteModal()">
        <span class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span>
      </button>
    </div>
  </div>
</div>
